// extracted by mini-css-extract-plugin
export default {"root":"PoweredBy_root__iEVtA"};